import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import Image from '../elements/Image';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}
const Tokenomics = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {

  const outerClasses = classNames(
    'features-tiles section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

 const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const tilesClasses = classNames(
    'tiles-wrap center-content',
    pushLeft && 'push-left'
    
  );



  return (
    <section id="Tokenomics"
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
             <h1 className="mt-16 mb-64 center-content reveal-from-bottom" data-reveal-delay="200">
             <span className="text-color-primary">Dogecoin v2 Tokenomics</span>
            </h1>
                  
                  
                  <div className='m-12 mt-12 mb-12 reveal-from-bottom center-content'>
                      <p>
                       At DOGECOIN v2, we believe in the power of marketing to drive awareness, adoption, and growth. To ensure the success of our mission, we have implemented a 1% fee on all transactions, specifically designated for our robust marketing initiatives.
                      </p>

                      <p>
                       With a total supply of 1,000,000,000 DOGECOIN v2, this fee structure enables us to generate the necessary funds to fuel impactful marketing campaigns. Our dedicated marketing team will utilize these funds strategically to reach wider audiences, engage with potential investors, and expand the DOGECOIN v2 ecosystem.
                      </p>
                      <p>
                    Join us as we unleash the power of marketing to drive the success of DOGECOIN v2. Together, we can propel this revolutionary token to new heights, revolutionize decentralized finance, and leave a lasting impact on the crypto world.
                      </p>

                  </div>



            <div className={tilesClasses}>

            <div className="tiles-item reveal-from-bottom">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/logo.png')}
                      alt="Features tile icon 01"
                      width={80}
                      height={80} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Total Supply
                    </h4>
                  <p className="m-0 text-sm">
                 1,000,000,000
                 </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/logo.png')}
                      alt="Features tile icon 02"
                      width={80}
                      height={80} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                   Marketing Fee
                    </h4>
                  <p className="m-0 text-sm">
                   1%   </p>
                </div>
              </div>
            </div>

               <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/logo.png')}
                      alt="Features tile icon 02"
                      width={80}
                      height={80} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                   Liquidity Locked
                    </h4>
                  <p className="m-0 text-sm">
                   100%   </p>
                </div>
              </div>
              
            </div>
                
                
                <div className='m-12 mt-12 mb-12 reveal-from-bottom center-content'>
    
                       <p >
                  Note: The allocation of marketing funds remains unchanged despite the contract renouncement.   </p>
         
              </div>


        

          </div>
        </div>
      </div>
    </section>
  );
}

Tokenomics.propTypes = propTypes;
Tokenomics.defaultProps = defaultProps;

export default Tokenomics;